<template>
    <Fragment>
        <!-- TOGGLE EDITION MODE -->
        <button
            v-if="editActions"
            type="button"
            class="btn btn-dark ml-2 text-center"
            @click="project.isEditing = !project.isEditing"
        >
            <i v-show="!project.isEditing" class="fas fa-edit"></i>
            <i
                v-show="project.isEditing"
                @click="updateProject()"
                class="fas fa-save"
            ></i>
        </button>

        <!-- SELECTION MODE -->
        <button
            v-if="selectionActions"
            type="button"
            class="btn btn-dark ml-2 text-center"
            @click="app.configs.selectionMode = !app.configs.selectionMode"
        >
            <span v-if="!app.configs.selectionMode">Download</span>
            <span v-if="app.configs.selectionMode">Cancel</span>
        </button>

        <!-- DOWNLOAD EXCEL -->
        <button
            type="button"
            class="btn btn-dark m-2"
            v-if="selectionActions && app.configs.selectionMode"
            @click="downloadSelectionExcel()"
        >
            <!-- {{ $t("popup_myconfigs_download_excel") }} -->
            <i title="Excel" class="fas fa-file-excel"></i>
        </button>

        <!-- DOWNLOAD PDF -->
        <button
            type="button"
            class="btn btn-dark m2"
            v-if="selectionActions && app.configs.selectionMode"
            @click="downloadSelectionPdf()"
        >
            <!-- {{ $t("popup_myconfigs_download_pdf") }} -->
            <i title="PDF" class="fas fa-file-pdf"></i>
        </button>

        <!-- DELETE PROJECT -->
        <button
            v-if="editActions"
            type="button"
            class="btn btn-dark ml-2 text-center"
            @click="removeProject()"
        >
            <i class="fas fa-trash-alt"></i>
        </button>

        <button
            v-if="closeAction"
            type="button"
            class="btn btn-dark m-2"
            data-bs-dismiss="modal"
            data-dismiss="modal"
        >
            {{ $t("popup_myconfigs_close") }}
        </button>
    </Fragment>
</template>

<script>
import { app } from "../../application.js";
import { Fragment } from "vue-fragment";
import jQuery from "jquery";
export default {
    name: 'projectsActionComponent',
    props: {
        project: {},
        editActions: false,
        selectionActions: false,
        closeAction: false
    },

    components: {
        Fragment,
    },
    data() {
        return {
            app: app,
        }
    },
    methods: {
        async updateProject() {
            await this.app.API.updateProject(this.project)
            await this.app.projects.refresh()
        },
        async removeProject() {
            if (await this.app.projects.remove(this.project.id)) {
                // Closes view Project modal
                jQuery(".viewProjectModal").modal("hide");
            }
        },
        downloadSelectionExcel: async function () {
            await this.app.API.downloadByIds(
                "xlsx",
                this.app.configs.getSelectedConfigurationsIds(this.project)
            );
        },
        downloadSelectionPdf: async function () {
            await this.app.API.downloadByIds(
                "pdf",
                this.app.configs.getSelectedConfigurationsIds(this.project)
            );
        },
    }
}
</script>

<style>
</style>